'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isMultiLocationSite;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Properties = require('./Properties');

var _Properties2 = _interopRequireDefault(_Properties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMultiLocationSite(organization) {
    return _lodash2.default.get(_Properties2.default.get(organization, 'wixrestaurants', 'com.wix.restaurants'), 'isMultiLocationEnabled', false);
}